import Registration from './components/Registration.vue';

const routes = [{ path: '/', component: Registration, name: 'register' }];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js